import React, { memo, useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap';
import { getCountries, getCountryCallingCode } from 'react-phone-number-input';
import en from 'react-phone-number-input/locale/en';
import ar from "react-phone-number-input/locale/ar";
import PhoneData from "../countryData.json";
// import PhoneZones from '../locales/phoneZones.json';

 const CountrySelect = memo(({ labels ,country , setCountry}) => {
  console.log("country")
 const [searchCountry, setSearchCountry] = useState('');
 const filtercountries = getCountries()
   .filter((country) => labels[country].toLowerCase().includes(searchCountry.toLowerCase()))
   .sort((a, b) => (labels[a] || "").localeCompare(labels[b] || "", undefined, { sensitivity: "base" }));
 const filteredCodes = getCountries()
   .filter((country) => getCountryCallingCode(country).includes(searchCountry))
   .sort((a, b) => (labels[a] || "").localeCompare(labels[b] || "", undefined, { sensitivity: "base" }));

 return (
 <Dropdown className='phonenumber-field'>
 {/* <Dropdown.Toggle>
 +{getCountryCallingCode(((country !== undefined) && (country !== null)) ? country : 'US')}
 </Dropdown.Toggle> */}

 <Dropdown.Toggle
 variant="default"
 id="dropdown-country-select"
 className="d-flex align-items-center gap-1 border-0 shadow-none px-2"
 style={{ minWidth: "105px", height: "44px" }}
 >
 {country ? (
 <>
 {['AC', 'TA'].includes(country) ? (
 <span style={{ fontSize: '23px' }}>
 {country === 'AC' ? '🇦🇨' : '🇹🇦'}
 </span>
 ) : (
 <img
 src={`https://flagcdn.com/24x18/${country.toLowerCase()}.png`}
 alt={country}
 style={{ width: "28px", height: "21px", borderRadius: "3px" }}
 />
 )}
 <span className="fw-medium">
 +{getCountryCallingCode(country)}
 </span>
 {/* <i className="fa fa-chevron-down"></i> */}
 </>
 ) : (
 <span className="text-muted small">+{("SelectCountry")}</span>
 )}
 </Dropdown.Toggle>

 <Dropdown.Menu className='phone-dropdown-menu'>
 <div className="col-md-12 position-relative">
 <div className='d-flex align-items-center'>
 <span class="search-icon position-absolute search-icon-store">
 <i class="fa fa-search"></i>
 </span>
 <input
 type="text"
 className="phone-search-input ps-5 border-top w-100 border-bottom py-2"
 placeholder="Search"
 value={searchCountry}
 onChange={(e) => setSearchCountry(e.target.value)}
 />
 </div>
 </div>
 {(filtercountries?.length > 0 ? filtercountries : filteredCodes).map((country) =>
 <Dropdown.Item key={country} onClick={() => {
 setCountry(country);
// localStorage.setItem("isPhone",JSON.stringify(true));
 }}>
 <div style={{ display: "flex", gap: "10px" }}>
 {['AC', 'TA'].includes(country) ? (
 <span style={{ fontSize: '23px' }}>
 {country === 'AC' ? '🇦🇨' : '🇹🇦'}
 </span>
 ) : (
 <img
 src={`https://flagcdn.com/24x18/${country.toLowerCase()}.png`}
 alt={country}
 style={{ width: "28px", height: "21px", borderRadius: "3px" }}
 />
 )}

 {labels[country]} (+{getCountryCallingCode(country)})
 {/* {labels[country]} +{getCountryCallingCode(country)} */}
 </div>
 </Dropdown.Item>
 )}
 </Dropdown.Menu>
 </Dropdown>
 )
 });

const PhoneNumber = memo(({ country, setCountry, phoneNumber, handleChange ,onBlur  }) => {

 const countryLabels = {
 en: en,
 ar: ar,
 };

 const labels = en;
 console.log("test")

// const isPhone = JSON.parse(localStorage.getItem("isPhone"));
// const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
// const PhoneDetails = PhoneZones[userTimeZone];
// console.log(PhoneDetails, getCountries(), getCountryCallingCode(PhoneDetails?.phoneCode));

// useEffect(() => {
// if (!isPhone && PhoneDetails) {
// setCountry(PhoneDetails?.phoneCode);
// }
// }, []);



 return (
 <div className='d-flex signup-phnumber-field-wrap w-100' dir="ltr" >
 <CountrySelect labels={labels} country={country} setCountry={setCountry}/>
 <input
 type="text"
 placeholder={("Enter Mobile Number")}
 value={phoneNumber}
 className='form-control'
 autoComplete="off"
 name="phone-national"
 onBlur={(e) => {
   const cleaned = e.target.value.replace(/\D/g, "");
   handleChange(cleaned);
   onBlur?.();
 }}
 onChange={(e) => {
 const cleaned = e.target.value.replace(/\D/g, "");
 handleChange(cleaned);
}}
 onKeyPress={(event) => {
 if (!/^\d+$/.test(event.key) && event.key !== 'Backspace') {
 event.preventDefault();
 }
 }}
 maxLength={PhoneData[country] ?? 15}
 />
 </div>
 )
})

export default PhoneNumber;